import { ApolloClient, NormalizedCacheObject, useQuery } from '@apollo/client';

import POSTS_QUERY from 'graphql/post/queries/posts.graphql';

import type { GetPostsQuery, GetPostsQueryVariables } from 'graphql/types';

export const usePosts = (variables?: GetPostsQueryVariables) =>
  useQuery<GetPostsQuery>(POSTS_QUERY, { variables });

export const getPostsSsr = async (
  client: ApolloClient<NormalizedCacheObject>,
  variables?: GetPostsQueryVariables
) => {
  try {
    return client.query({
      query: POSTS_QUERY,
      variables,
    });
  } catch (err) {
    console.log(err);
  }
};
